<template>
  <v-card dark>
    <v-card-title class="d-flex justify-center">
      <h3 class="text-h6">Ativar Integração IFOOD</h3>
    </v-card-title>
    <v-card-text>
      <template>
        <v-stepper v-model="step" vertical>
          <v-stepper-step :complete="step > 1" step="1">
            Passo 1
            <small>Gerar código de ativação</small>
          </v-stepper-step>

          <v-stepper-content step="1">
            <v-row no-gutters dense class="mt-3">
              <v-col cols="8">
                <c-input
                  :maxLength="255"
                  label="Url para ativação"
                  placeholder="Url para ativação"
                  v-model="contract.url"
                  :disabled="blockedTime"
                />
              </v-col>
              <v-col cols="2">
                <v-btn
                  color="success"
                  :disabled="blockedTime"
                  class="ml-3"
                  @click="activate"
                >
                  <span class="text-overline">Ativar</span>
                  <v-icon right>mdi-arrow-right-bold-box</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-stepper-content>

          <v-stepper-step :complete="step > 2" step="2">
            Passo 2
            <small>Gravar código do Parceiro</small>
          </v-stepper-step>

          <v-stepper-content step="2">
            <v-row no-gutters dense class="mt-2">
              <v-col cols="8">
                <c-input
                  :maxLength="15"
                  label="Código Parceiro"
                  placeholder="Código Parceiro"
                  v-model="form.authCodePartner"
                  :isRequired="true"
                />
              </v-col>

              <v-col cols="2">
                <v-btn color="success" class="ml-3" @click="updateAuthCode">
                  <span class="text-overline">Salvar</span>
                  <v-icon right>mdi-content-save</v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <v-btn color="primary" class="ml-2" @click="toStep(1)" small>
              Voltar
            </v-btn>
          </v-stepper-content>

          <v-stepper-step :complete="step > 3" step="3">
            Passo 3
            <small>Informar Merchant</small>
          </v-stepper-step>

          <v-stepper-content step="3">
            <v-row no-gutters dense class="mt-2">
              <v-col cols="8">
                <c-select
                  class="ml-2"
                  rotulo="ID Merchant"
                  itemText="name"
                  itemValue="id"
                  :lista="merchantsList"
                  :item.sync="form.merchant"
                  :isRequired="true"
                />
              </v-col>
              <v-col cols="2">
                <v-btn color="success" class="ml-3" @click="updateIdMerchant">
                  <span class="text-overline">Salvar</span>
                  <v-icon right>mdi-content-save</v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <v-btn color="primary" class="ml-2" @click="toStep(2)" small>
              Voltar
            </v-btn>
          </v-stepper-content>
        </v-stepper>
      </template>
    </v-card-text>
    <v-card-actions>
      <v-btn color="red darken-4" @click="cancelar" small>
        <span class="text-overline">Fechar</span>
      </v-btn>
      <v-spacer />
      <span
        v-if="message != ''"
        :class="blockedTime ? 'red--text' : 'green--text'"
      >
        <v-icon :class="blockedTime ? 'red--text' : 'green--text'">
          {{ blockedTime ? 'mdi-alert' : 'mdi-clock-time-one' }}
        </v-icon>
        {{ message }}
      </span>
      <v-spacer />
      <v-btn
        color="success"
        :disabled="!blockedTime"
        v-if="blockedTime"
        class="ml-3"
        @click="updateContract"
        small
      >
        <span class="text-overline">Atualizar</span>
        <v-icon right>mdi-update</v-icon>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import { mapActions, mapState } from 'vuex'

export default {
  components: {
    cInput: () => import('@/components/shared/base-input/BaseInput'),
    cSelect: () => import('@/components/shared/base-input/BaseSelect.vue'),
  },
  props: {
    saveAuthCodePartner: Function,
    saveIdMerchant: Function,
    contract: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      step: 1,
      timerInterval: null,
      time: 0,
      timeToRedirect: 5,
      blockedTime: false,
      message: '',
      form: {
        merchant: {},
        authCodePartner: '',
      },
    }
  },
  watch: {
    contract(newValue) {
      try {
        console.log(newValue)
        this.time = newValue.expires_in
        this.message = ''
        this.blockedTime = false
        if (Object.keys(newValue).length > 0) this.initCont()
      } finally {
        this.showLoadingDialog(false)
      }
    },
  },
  computed: {
    ...mapState('ifoodModule', ['merchantsList']),
  },
  methods: {
    ...mapActions({
      getMerchants: 'ifoodModule/getMerchants',
      showLoadingDialog: 'dialogModule/setShowLoadingDialog',
      setLoadingDialogMessage: 'dialogModule/setLoadingDialogMessage',
    }),
    updateContract() {
      this.$emit('updateContract')
    },
    activate() {
      this.message = ''
      this.toStep(2)
      this.time = this.timeToRedirect
      clearInterval(this.timerInterval)
      this.timerInterval = setInterval(() => {
        this.message = `Redirecionando em ${this.time} segundos`
        if (this.time == 0) {
          this.blockedTime = false
          this.message = ''
          clearInterval(this.timerInterval)
          window.open(this.contract.url, '_blank')
        }
        --this.time
      }, 1000)
    },
    cancelar() {
      this.$emit('close')
      this.message = ''
      clearInterval(this.timerInterval)
    },
    initCont() {
      clearInterval(this.timerInterval)
      this.timerInterval = setInterval(() => {
        this.message = `Tempo para ativação: ${this.time} segundos`
        if (this.time <= 0) {
          this.blockedTime = true
          this.message = 'Tempo de ativação expirado!'
          clearInterval(this.timerInterval)
        }
        --this.time
      }, 1000)
    },
    async updateAuthCode() {
      try {
        if (this.form.authCodePartner == '') {
          this.$toasted.error('Preencha o código do parceiro.', {
            duration: 3000,
          })
          return
        }
        this.setLoadingDialogMessage('Salvando código parceiro')
        this.showLoadingDialog(true)

        await this.saveAuthCodePartner(this.form.authCodePartner)

        this.toStep(3)
        this.$toasted.success('Código do parceiro gravado.', {
          duration: 3000,
        })
      } catch (error) {
        this.$toasted.error(error, {
          duration: 3000,
        })
      } finally {
        this.showLoadingDialog(false)
      }
    },
    async updateIdMerchant() {
      try {
        if (!this.form.merchant.id) {
          this.$toasted.error('Selecione um opção!', {
            duration: 3000,
          })
          return
        }
        this.setLoadingDialogMessage('Salvando Loja...')
        this.showLoadingDialog(true)

        await this.saveIdMerchant(this.form.merchant.id)

        this.$toasted.success('Loja atualizada.', {
          duration: 3000,
        })
        this.$emit('close')
      } catch (error) {
        this.$toasted.error(error, {
          duration: 3000,
        })
      } finally {
        this.showLoadingDialog(false)
      }
    },
    async toStep(nextStep) {
      switch (nextStep) {
        case 1:
          this.step = 1
          break
        case 2:
          this.step = 2
          break
        case 3:
          this.step = 3
          await this.getMerchants()
          break
      }
    },
  },
  async mounted() {
    this.setLoadingDialogMessage('Gerando código de ativação...')
    this.showLoadingDialog(true)
  },
}
</script>
